import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Table } from 'react-bootstrap';
import { isEmpty } from 'lodash';

class ManageTable extends PureComponent {
    static propTypes = {
        isStriped: PropTypes.bool,
        isBordered: PropTypes.bool,
        isCondensed: PropTypes.bool,
        isHover: PropTypes.bool,
        getRowKey: PropTypes.func,
        columnProperties: PropTypes.arrayOf(
            PropTypes.shape({
                columnName: PropTypes.string,
                columnClassName: PropTypes.string,
                columnRowClassName: PropTypes.string,
                columnRowRenderer: PropTypes.func,
                columnWidth: PropTypes.string
            })
        ),
        objectArray: PropTypes.array,
        selectColumnToSort: PropTypes.func
    };

    /**
     *
     * @param {String} item
     * @return {XML}
     * @private
     */
    _generateColumn = (item) => {
        const { selectColumnToSort } = this.props;
        const { columnName, columnClassName, columnPropertyName, columnWidth } = item;
        let headerSortFunc;
        if (selectColumnToSort) {
            headerSortFunc = () => selectColumnToSort(columnPropertyName);
        }
        return (
            <th
                key={columnName}
                className={cns(columnClassName, { 'table-clickable-header': !!headerSortFunc })}
                onClick={headerSortFunc}
                style={{ width: columnWidth }}
            >
                {columnName}
            </th>
        );
    };

    /**
     *
     * @return {XML}
     * @private
     */
    _generateColumns = () => {
        const { columnProperties } = this.props;

        return <tr>{columnProperties.map((item) => this._generateColumn(item))}</tr>;
    };

    _generateRow = (object) => {
        const { columnProperties, getRowKey } = this.props;

        const rowCells = columnProperties.map((item) => (
            <td
                key={`${getRowKey(object)}-${item.columnName}`}
                className={cns(item.columnRowClassName)}
                style={item.columnWidth ? { width: `${item.columnWidth}px` } : {}}
            >
                {item.columnRowRenderer(object)}
            </td>
        ));

        return <tr key={getRowKey(object)}>{rowCells}</tr>;
    };

    _generateRows = () => {
        const { objectArray } = this.props;

        if (isEmpty(objectArray)) {
            return null;
        }

        return (
            <tbody>
                {objectArray.map((item) => {
                    if (isEmpty(item)) {
                        return null;
                    }
                    return this._generateRow(item);
                })}
            </tbody>
        );
    };

    render() {
        const { isStriped = false, isBordered = false, isCondensed = false, isHover = true } = this.props;

        return (
            <Table
                striped={isStriped}
                bordered={isBordered}
                size={isCondensed ? 'sm' : ''}
                hover={isHover}
                className={'manage-table'}
            >
                <thead>{this._generateColumns()}</thead>
                {this._generateRows()}
            </Table>
        );
    }
}

export default ManageTable;
